export default __webpack_public_path__ + "static/Roofing-Dumpsters-da9795b296d678be2365eb14ccd60c28.jpg";